import gql from 'graphql-tag';

export const CHECK_CONNECTION = gql`
  query CheckConnection {
    checkConnection
  }
`;
